import dynamic from "next/dynamic";

import styles from "./card-list.module.scss";
import { CardListStoryblok } from "@/types/component-types-sb";

const CardListItem = dynamic(() => import("./CardListItem"), { ssr: false });

interface Props {
  blok: CardListStoryblok;
}

const CardList = (props: Props) => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.innerWrapper}>
          {(props.blok.items || []).map((item) => (
            <CardListItem key={item._uid} blok={item} />
          ))}
        </div>
      </div>
    </>
  );
};

export default CardList;
